function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg191Tubalu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#338AF3"
    },
    width: 512,
    height: 512
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "309.875,348.69 314.257,362.178 328.438,362.178 316.966,370.513 321.348,384    309.875,375.664 298.401,384 302.785,370.513 291.31,362.178 305.491,362.178  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "422.815,260.414 427.198,273.902 441.38,273.902 429.907,282.237 434.29,295.725    422.815,287.389 411.343,295.725 415.726,282.237 404.252,273.902 418.433,273.902  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "451.115,128 455.499,141.488 469.68,141.488 458.207,149.823 462.59,163.31    451.115,154.975 439.643,163.31 444.026,149.823 432.552,141.488 446.733,141.488  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "458.126,225.103 462.509,238.591 476.69,238.591 465.218,246.926 469.6,260.414    458.126,252.079 446.653,260.414 451.036,246.926 439.562,238.591 453.743,238.591  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "330.21,316.968 342.846,323.407 352.874,313.38 350.657,327.385 363.292,333.823    349.284,336.042 347.066,350.049 340.629,337.412 326.62,339.633 336.648,329.606  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "330.21,264.003 342.846,270.442 352.874,260.414 350.657,274.42 363.292,280.858    349.284,283.077 347.066,297.084 340.629,284.447 326.62,286.668 336.648,276.639  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "374.348,297.954 386.984,304.392 397.013,294.364 394.794,308.371 407.43,314.809    393.422,317.027 391.204,331.035 384.767,318.398 370.759,320.618 380.787,310.59  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "374.348,184.555 386.984,190.993 397.013,180.965 394.794,194.972 407.43,201.41    393.422,203.629 391.204,217.636 384.767,204.999 370.759,207.219 380.787,197.191  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFDA44"
    },
    points: "417.125,183.195 429.763,189.634 439.79,179.606 437.572,193.612 450.207,200.05    436.199,202.269 433.981,216.275 427.543,203.639 413.537,205.86 423.564,195.832  "
  })), /*#__PURE__*/React.createElement("rect", {
    y: 0,
    style: {
      fill: "#F0F0F0"
    },
    width: 256,
    height: 256
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152.001 104.001,152.001 104.001,256.001 152.001,256.001 152.001,152.001 256,152.001   256,104.001 152.001,104.001 152.001,0.001 104.001,0.001 104.001,104.001 0,104.001 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "203.46,166.958 256,219.498 256,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "232.282,256.001 166.957,190.67 166.957,256.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.957,166.958 256,256.001 256,230.821 192.137,166.958 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "40.151,166.958 0,207.108 0,166.958  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.041,178.281 89.041,255.999 11.33,255.999  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.96 0,230.822 0,256.001 0,256.001 89.041,166.96 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "52.54,89.045 0,36.504 0,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "23.718,0.001 89.043,65.332 89.043,0.001  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.045 0,0.001 0,25.181 63.863,89.045 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "215.849,89.045 256,48.894 256,89.045  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.959,77.722 166.959,0.002 244.67,0.002  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.138,89.042 256,25.18 256,0.001 256,0.001 166.959,89.042 "
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg191Tubalu);
export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8IS0tIEdlbmVyYXRvcjogQWRvYmUgSWxsdXN0cmF0b3IgMTkuMC4wLCBTVkcgRXhwb3J0IFBsdWctSW4gLiBTVkcgVmVyc2lvbjogNi4wMCBCdWlsZCAwKSAgLS0+CjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDUxMiA1MTIiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDUxMiA1MTI7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4KPHJlY3Qgc3R5bGU9ImZpbGw6IzMzOEFGMzsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIi8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzA5Ljg3NSwzNDguNjkgMzE0LjI1NywzNjIuMTc4IDMyOC40MzgsMzYyLjE3OCAzMTYuOTY2LDM3MC41MTMgMzIxLjM0OCwzODQgICAgMzA5Ljg3NSwzNzUuNjY0IDI5OC40MDEsMzg0IDMwMi43ODUsMzcwLjUxMyAyOTEuMzEsMzYyLjE3OCAzMDUuNDkxLDM2Mi4xNzggICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iNDIyLjgxNSwyNjAuNDE0IDQyNy4xOTgsMjczLjkwMiA0NDEuMzgsMjczLjkwMiA0MjkuOTA3LDI4Mi4yMzcgNDM0LjI5LDI5NS43MjUgICAgNDIyLjgxNSwyODcuMzg5IDQxMS4zNDMsMjk1LjcyNSA0MTUuNzI2LDI4Mi4yMzcgNDA0LjI1MiwyNzMuOTAyIDQxOC40MzMsMjczLjkwMiAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSI0NTEuMTE1LDEyOCA0NTUuNDk5LDE0MS40ODggNDY5LjY4LDE0MS40ODggNDU4LjIwNywxNDkuODIzIDQ2Mi41OSwxNjMuMzEgICAgNDUxLjExNSwxNTQuOTc1IDQzOS42NDMsMTYzLjMxIDQ0NC4wMjYsMTQ5LjgyMyA0MzIuNTUyLDE0MS40ODggNDQ2LjczMywxNDEuNDg4ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjQ1OC4xMjYsMjI1LjEwMyA0NjIuNTA5LDIzOC41OTEgNDc2LjY5LDIzOC41OTEgNDY1LjIxOCwyNDYuOTI2IDQ2OS42LDI2MC40MTQgICAgNDU4LjEyNiwyNTIuMDc5IDQ0Ni42NTMsMjYwLjQxNCA0NTEuMDM2LDI0Ni45MjYgNDM5LjU2MiwyMzguNTkxIDQ1My43NDMsMjM4LjU5MSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSIzMzAuMjEsMzE2Ljk2OCAzNDIuODQ2LDMyMy40MDcgMzUyLjg3NCwzMTMuMzggMzUwLjY1NywzMjcuMzg1IDM2My4yOTIsMzMzLjgyMyAgICAzNDkuMjg0LDMzNi4wNDIgMzQ3LjA2NiwzNTAuMDQ5IDM0MC42MjksMzM3LjQxMiAzMjYuNjIsMzM5LjYzMyAzMzYuNjQ4LDMyOS42MDYgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzMwLjIxLDI2NC4wMDMgMzQyLjg0NiwyNzAuNDQyIDM1Mi44NzQsMjYwLjQxNCAzNTAuNjU3LDI3NC40MiAzNjMuMjkyLDI4MC44NTggICAgMzQ5LjI4NCwyODMuMDc3IDM0Ny4wNjYsMjk3LjA4NCAzNDAuNjI5LDI4NC40NDcgMzI2LjYyLDI4Ni42NjggMzM2LjY0OCwyNzYuNjM5ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiNGRkRBNDQ7IiBwb2ludHM9IjM3NC4zNDgsMjk3Ljk1NCAzODYuOTg0LDMwNC4zOTIgMzk3LjAxMywyOTQuMzY0IDM5NC43OTQsMzA4LjM3MSA0MDcuNDMsMzE0LjgwOSAgICAzOTMuNDIyLDMxNy4wMjcgMzkxLjIwNCwzMzEuMDM1IDM4NC43NjcsMzE4LjM5OCAzNzAuNzU5LDMyMC42MTggMzgwLjc4NywzMTAuNTkgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6I0ZGREE0NDsiIHBvaW50cz0iMzc0LjM0OCwxODQuNTU1IDM4Ni45ODQsMTkwLjk5MyAzOTcuMDEzLDE4MC45NjUgMzk0Ljc5NCwxOTQuOTcyIDQwNy40MywyMDEuNDEgICAgMzkzLjQyMiwyMDMuNjI5IDM5MS4yMDQsMjE3LjYzNiAzODQuNzY3LDIwNC45OTkgMzcwLjc1OSwyMDcuMjE5IDM4MC43ODcsMTk3LjE5MSAgIi8+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojRkZEQTQ0OyIgcG9pbnRzPSI0MTcuMTI1LDE4My4xOTUgNDI5Ljc2MywxODkuNjM0IDQzOS43OSwxNzkuNjA2IDQzNy41NzIsMTkzLjYxMiA0NTAuMjA3LDIwMC4wNSAgICA0MzYuMTk5LDIwMi4yNjkgNDMzLjk4MSwyMTYuMjc1IDQyNy41NDMsMjAzLjYzOSA0MTMuNTM3LDIwNS44NiA0MjMuNTY0LDE5NS44MzIgICIvPgo8L2c+CjxyZWN0IHk9IjAiIHN0eWxlPSJmaWxsOiNGMEYwRjA7IiB3aWR0aD0iMjU2IiBoZWlnaHQ9IjI1NiIvPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgcG9pbnRzPSIwLDE1Mi4wMDEgMTA0LjAwMSwxNTIuMDAxIDEwNC4wMDEsMjU2LjAwMSAxNTIuMDAxLDI1Ni4wMDEgMTUyLjAwMSwxNTIuMDAxIDI1NiwxNTIuMDAxICAgMjU2LDEwNC4wMDEgMTUyLjAwMSwxMDQuMDAxIDE1Mi4wMDEsMC4wMDEgMTA0LjAwMSwwLjAwMSAxMDQuMDAxLDEwNC4wMDEgMCwxMDQuMDAxICIvPgo8Zz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9IjIwMy40NiwxNjYuOTU4IDI1NiwyMTkuNDk4IDI1NiwxNjYuOTU4ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9IjE2Ni45NTcsMTY2Ljk1OCAyNTYsMjU2LjAwMSAyNTYsMjMwLjgyMSAxOTIuMTM3LDE2Ni45NTggICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHBvaW50cz0iMjMyLjI4MiwyNTYuMDAxIDE2Ni45NTcsMTkwLjY3IDE2Ni45NTcsMjU2LjAwMSAgIi8+CjwvZz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0YwRjBGMDsiIHBvaW50cz0iMTY2Ljk1NywxNjYuOTU4IDI1NiwyNTYuMDAxIDI1NiwyMzAuODIxIDE5Mi4xMzcsMTY2Ljk1OCAiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHBvaW50cz0iMTY2Ljk1NywxNjYuOTU4IDI1NiwyNTYuMDAxIDI1NiwyMzAuODIxIDE5Mi4xMzcsMTY2Ljk1OCAiLz4KPGc+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgcG9pbnRzPSI0MC4xNTEsMTY2Ljk1OCAwLDIwNy4xMDggMCwxNjYuOTU4ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9Ijg5LjA0MSwxNzguMjgxIDg5LjA0MSwyNTUuOTk5IDExLjMzLDI1NS45OTkgICIvPgo8L2c+Cjxwb2x5Z29uIHN0eWxlPSJmaWxsOiNEODAwMjc7IiBwb2ludHM9IjYzLjg2MiwxNjYuOTYgMCwyMzAuODIyIDAsMjU2LjAwMSAwLDI1Ni4wMDEgODkuMDQxLDE2Ni45NiAiLz4KPGc+Cgk8cG9seWdvbiBzdHlsZT0iZmlsbDojMDA1MkI0OyIgcG9pbnRzPSI1Mi41NCw4OS4wNDUgMCwzNi41MDQgMCw4OS4wNDUgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHBvaW50cz0iODkuMDQzLDg5LjA0NSAwLDAuMDAxIDAsMjUuMTgxIDYzLjg2Myw4OS4wNDUgICIvPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHBvaW50cz0iMjMuNzE4LDAuMDAxIDg5LjA0Myw2NS4zMzIgODkuMDQzLDAuMDAxICAiLz4KPC9nPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRjBGMEYwOyIgcG9pbnRzPSI4OS4wNDMsODkuMDQ1IDAsMC4wMDEgMCwyNS4xODEgNjMuODYzLDg5LjA0NSAiLz4KPHBvbHlnb24gc3R5bGU9ImZpbGw6I0Q4MDAyNzsiIHBvaW50cz0iODkuMDQzLDg5LjA0NSAwLDAuMDAxIDAsMjUuMTgxIDYzLjg2Myw4OS4wNDUgIi8+CjxnPgoJPHBvbHlnb24gc3R5bGU9ImZpbGw6IzAwNTJCNDsiIHBvaW50cz0iMjE1Ljg0OSw4OS4wNDUgMjU2LDQ4Ljg5NCAyNTYsODkuMDQ1ICAiLz4KCTxwb2x5Z29uIHN0eWxlPSJmaWxsOiMwMDUyQjQ7IiBwb2ludHM9IjE2Ni45NTksNzcuNzIyIDE2Ni45NTksMC4wMDIgMjQ0LjY3LDAuMDAyICAiLz4KPC9nPgo8cG9seWdvbiBzdHlsZT0iZmlsbDojRDgwMDI3OyIgcG9pbnRzPSIxOTIuMTM4LDg5LjA0MiAyNTYsMjUuMTggMjU2LDAuMDAxIDI1NiwwLjAwMSAxNjYuOTU5LDg5LjA0MiAiLz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPGc+CjwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };